<div class="desktop-step-two desktop-filter-step">
  <div class="desktop-filter-step__side-by-side">
    <div class="desktop-filter-step__card">
      <div class="desktop-filter-step__row">
        <lib-price-filter (update)="onPriceChange($event)"></lib-price-filter>
      </div>

      <div class="desktop-filter-step__row" *ngIf="displayRoomCount">
        <lib-room-count-filter
          (update)="onRoomCountChange($event)"
        ></lib-room-count-filter>
      </div>

      <div class="desktop-filter-step__row" *ngIf="displayLivingSpace">
        <lib-living-space-filter
          (update)="onLivingSpaceChange($event)"
        ></lib-living-space-filter>
      </div>

      <div class="desktop-filter-step__row" *ngIf="displayUsageSpace">
        <lib-usage-space-filter
          (update)="onUsageSpaceChange($event)"
        ></lib-usage-space-filter>
      </div>

      <div class="desktop-filter-step__row" *ngIf="displayPropertySpace">
        <lib-property-space-filter
          (update)="onPropertySpaceChange($event)"
        ></lib-property-space-filter>
      </div>
    </div>

    <div class="desktop-filter-step__chips">
      <h4 class="desktop-filter-step__chips-title">
        {{ 'searchSubscription.yourSearchCriteria' | i18n }}
      </h4>

      <lib-filter-chips [alwaysOpen]="true"></lib-filter-chips>
    </div>
  </div>
</div>
